import React, { Component } from 'react';
import T from 'prop-types';
import _ from 'lodash';
import { CarouselProvider } from 'pure-react-carousel';
import { GalleryCarouselSlider } from '..';

import 'pure-react-carousel/dist/react-carousel.es.css';
import css from './GalleryCarouselWrapper.css';
import classNames from 'classnames';

const MODAL_BREAKPOINT = 768;

const isWindowDefined = typeof window !== 'undefined';
const isMobileLayout = isWindowDefined && window.innerWidth < MODAL_BREAKPOINT;

class GalleryCarouselWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showArrow: false,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { items, renderSizes, dragEnabled, pagination, actionItem } = this.props;
    const {
      items: nextItems,
      renderSizes: nextRenderSizes,
      dragEnabled: nextDragEnabled,
      pagination: nextPagination,
      actionItem: nextActionItem,
    } = nextProps;
    return (
      !_.isEqual(items, nextItems) ||
      renderSizes !== nextRenderSizes ||
      dragEnabled !== nextDragEnabled ||
      pagination !== nextPagination ||
      this.state.showArrow !== nextState.showArrow ||
      actionItem !== nextActionItem
    );
  }

  setShowArrow = value =>
    this.setState({
      showArrow: value,
    });

  render() {
    const { showArrow } = this.state;

    const {
      items: itemsFromProps,
      renderSizes,
      dragEnabled = true,
      touchEnabled = true,
      pagination = true,
      actionItem,
      rootClassName,
      children,
    } = this.props;

    const items = actionItem ? [...itemsFromProps, actionItem] : itemsFromProps;

    return (
      <CarouselProvider
        naturalSlideWidth={100}
        naturalSlideHeight={50}
        totalSlides={items.length}
        dragEnabled={dragEnabled}
        touchEnabled={touchEnabled}
        className={classNames({
          [css.galleryCarouselWrapper]: true,
          [rootClassName]: !!rootClassName,
        })}
        onMouseEnter={() => this.setShowArrow(true)}
        onMouseLeave={() => this.setShowArrow(false)}
      >
        <GalleryCarouselSlider
          pagination={pagination}
          showArrow={!isMobileLayout && showArrow}
          renderSizes={renderSizes}
          notifyOnSlideChange={this.props.notifyOnSlideChange}
          {...this.props}
          items={items}
        >
          {children}
        </GalleryCarouselSlider>
      </CarouselProvider>
    );
  }
}

GalleryCarouselWrapper.propTypes = {
  items: T.array.isRequired,
  renderSizes: T.string.isRequired,
  dragEnabled: T.bool,
  pagination: T.bool,
};

export default GalleryCarouselWrapper;
